export class SharedPtable {
  id: number;
  name: string;
  // if calendar is used to pick a range, you may need this
  // change the variable name as necessary
  calendarStartOn: string;
  calendarEndOn: string;
}
